import { render, staticRenderFns } from "./BigSelect.vue?vue&type=template&id=1428fd2a&scoped=true&"
import script from "./BigSelect.vue?vue&type=script&lang=js&"
export * from "./BigSelect.vue?vue&type=script&lang=js&"
import style0 from "./BigSelect.vue?vue&type=style&index=0&id=1428fd2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1428fd2a",
  null
  
)

export default component.exports